import React from 'react';
import ServiceLandingPage from './ServiceLandingPage';
import auxiliarImg from '../../assets/auxiliar.jpg';

const AtencionPostoperatoria = () => {
  const pageData = {
    title: "Atención Postoperatoria",
    metaDescription: "Cuidados postoperatorios profesionales a domicilio en Guadalajara. Enfermeras especializadas para recuperación segura después de cirugías.",
    heroTitle: "Atención Postoperatoria a Domicilio",
    heroSubtitle: "Recuperación segura y profesional después de tu cirugía en la comodidad de tu hogar",
    description: "Nuestro servicio de atención postoperatoria brinda los cuidados especializados que necesitas después de una cirugía. Enfermeras tituladas con experiencia en recuperación quirúrgica aseguran que tu proceso de sanación sea óptimo, reduciendo riesgos de complicaciones y acelerando tu regreso a la normalidad.",
    benefits: [
      "Cuidado de heridas quirúrgicas y curaciones",
      "Monitoreo de signos de infección",
      "Administración de medicamentos y analgésicos",
      "Manejo de drenajes y catéteres",
      "Ejercicios de rehabilitación temprana",
      "Prevención de trombosis y escaras",
      "Coordinación con cirujano tratante",
      "Apoyo en movilización progresiva"
    ],
    features: [
      {
        title: "Curaciones Especializadas",
        description: "Cambio de apósitos y cuidado de heridas con técnica estéril"
      },
      {
        title: "Manejo del Dolor",
        description: "Administración oportuna de analgésicos y monitoreo de confort"
      },
      {
        title: "Vigilancia de Complicaciones",
        description: "Detección temprana de signos de alarma postquirúrgica"
      },
      {
        title: "Rehabilitación Temprana",
        description: "Ejercicios indicados para prevenir rigidez y acelerar recuperación"
      },
      {
        title: "Nutrición Postquirúrgica",
        description: "Supervisión de dieta especial para favorecer la cicatrización"
      },
      {
        title: "Reportes al Cirujano",
        description: "Informes detallados de evolución para el médico tratante"
      }
    ],
    faqs: [
      {
        question: "¿Cuánto tiempo después de la cirugía necesito una enfermera?",
        answer: "Depende del tipo de cirugía. Generalmente las primeras 48-72 horas son críticas. Algunas cirugías mayores requieren cuidados de 1-2 semanas. Te orientamos según las indicaciones de tu cirujano."
      },
      {
        question: "¿La enfermera puede cambiar mis drenajes?",
        answer: "Sí, nuestras enfermeras están capacitadas para el manejo de drenajes Jackson-Pratt, Penrose y otros, así como sondas vesicales y nasogástricas."
      },
      {
        question: "¿Qué tipos de cirugías atienden?",
        answer: "Atendemos recuperación de todo tipo de cirugías: ortopédicas (rodilla, cadera), abdominales, cardíacas, oncológicas, estéticas y más."
      },
      {
        question: "¿Pueden aplicar medicamentos intravenosos?",
        answer: "Sí, contamos con enfermeras generales tituladas que pueden canalizar venas y administrar medicamentos IV según prescripción médica."
      }
    ],
    image: auxiliarImg,
    relatedBlogSlugs: ['cuidados-postoperatorios-casa', 'signos-alarma-adultos-mayores']
  };

  return <ServiceLandingPage {...pageData} />;
};

export default AtencionPostoperatoria;
